import { assetEquipmentsSchema } from './schemas';
import { denormalize } from 'normalizr';

const DEFAULT_DATA = Object.assign({}, { equipments: [], loaded: false });
const getEquipmentsState = (state, ids) => denormalize(ids, [assetEquipmentsSchema], state);

export const getEquipments = (equipmentsCollection, assetHierarchyId) => {
  if (!assetHierarchyId) return DEFAULT_DATA;

  const data = equipmentsCollection[assetHierarchyId];
  if (!data) return DEFAULT_DATA;

  const { loading, loaded, ids } = data;
  if (!loaded || loading) return DEFAULT_DATA;

  const equipments = getEquipmentsState(equipmentsCollection, ids);
  return { equipments, loaded };
};

export const getHierarchyEquipmentsId = hierarchy => {
  const equipmentsTriggers = hierarchy?.filter(z => z.triggers.equipments && z.id).map(z => z.id) || [];
  if (equipmentsTriggers.length === 0) return null;
  return equipmentsTriggers[0];
};
